import React, { useEffect, useRef, useState } from "react";
import { localAttributes } from "assets/constants";
import { KeyValuePair } from "types";
import "instantsearch.css/themes/satellite.css";
import styles from "./SearchShaban.module.scss";
import Text from "components/text/Text";
import { getAllClassNames, isDev, setParams } from "helpers";
import strings from "assets/strings";
import { visitHoursOptions } from "assets/constants";
import { ArrowLeft, ArrowUp } from "assets/icons";
import Button from "components/buttons/button/Button";
//import { Popup } from "components/popup/Popup";
import { CustomLocalSearchInput } from "components/inputs/customLocalSearchInput/CustomLocalSearchInput";
import { CustomCheckboxesLocal } from "components/buttons/customCheckboxesLocal/CustomCheckboxesLocal";
import settings from "assets/mergeSettings";
//import { AlertPopup } from "components/popup/alertPopup/AlertPopup";
import RadioButton from "components/radioButton/RadioButton";
import { BubbleIcon } from "components/bubbleIcon/BubbleIcon";
import Popup from "components/popup/Popup";
import { AlertPopup } from "components/popup/alertPopup/AlertPopup";

//import { DropdownCheckboxes } from "components/dropdownCheckboxes/DropdownCheckboxes";

export function SearchShaban() {
  const [expanded, setExpanded] = useState(false);
  const [city, setCity] = useState("");
  const [name, setName] = useState("");
  const [groupCode, setgroupCode] = useState<number>(0);
  const [operationName, setoperationName] = useState<string>('')
  const [operationCode, setoperationCode] = useState<string>('')
  const [selectedFieldOfService, setSelectedFieldOfService] = useState<string>(strings.searchOperations.operationName)
  const [shouldResetOperationCode, setShouldResetOperationCode] = useState(false);
  const [shouldResetOperationName, setShouldResetOperationName] = useState(false);
  const divExpandRef = useRef<HTMLDivElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);

  const handleSelectedFieldOfService = (value: string) => {
    setSelectedFieldOfService(value)
    //setKey(prevKey => prevKey + 1);
    // Reset operation code if the selected service is "name"
    if (value === strings.searchOperations.operationCode) {
      setShouldResetOperationName(true);
      setShouldResetOperationCode(false);
      setoperationName('');
    }
    else {
      setShouldResetOperationCode(true);
      setShouldResetOperationName(false);
      setoperationCode('');
    }
  }

  useEffect(() => {
    if (divExpandRef.current && expanded) {
      const firstInput = divExpandRef.current.querySelector('input');
      if (firstInput) {
        firstInput.focus();
      }
    }
  }, [expanded]);

  const onSubmit = (event: any) => {
    event.preventDefault();

    if (selectedFieldOfService == strings.searchOperations.operationCode && !operationCode) {
      handleToggleVisibility();
      return;
    }

    if (selectedFieldOfService == strings.searchOperations.operationName && !operationName) {
      handleToggleVisibility();
      return;
    }

    //if (operationName || operationCode) {
    const formData: KeyValuePair[] = [
      { key: `${[localAttributes.localOperationGroupFieldName]}`, value: groupCode.toString() },
      { key: `${[localAttributes.localOperationNameFieldName]}`, value: operationName },
      { key: `${[localAttributes.localCityCodeFieldName]}`, value: city },
      { key: `${[localAttributes.localDoctorFieldName]}`, value: name },
      { key: `${[localAttributes.localOperationCodeFieldName]}`, value: String(operationCode) },
    ];
    window.location.href = `${settings.operationsSearchResults}?${setParams(formData)}`;
    // }
    // else {
    //   setShowPopup(true)
    // }
  };

  const handleToggleVisibility = () => {
    if (popupRef.current) {
      popupRef.current.classList.toggle('show');
    }
  };

  return (
    <div
      className={getAllClassNames([
        "ais-InstantSearch",
        isDev() && styles.devContainer,
      ])}
    >

      <div className={styles.container}>
        <div
          className={getAllClassNames([
            styles.searchDiv,
            expanded && styles.noBorderBottom,
          ])}
        >
          <div className={styles.searchDivWrapper}>
            <Text
              className={styles.serachTitle}
              text={strings.searchOuterServices.searchOuterServiceInstruction}
            />

            <div className={styles.searchFieldsWrapper}>
              {/* <div className={styles.divFlex}> */}
              <RadioButton
                value={strings.searchOperations.operationName}
                isSelected={selectedFieldOfService === strings.searchOperations.operationName}
                onSelecteRadio={(value: string) => handleSelectedFieldOfService(value)}
                //label={strings.searchOperations.operationName}
                id={'operationName'}
              />
              {/* 111111 */}
              <CustomLocalSearchInput
                key={`operationGroup-${selectedFieldOfService}`} // Dynamic key for re-rendering
                popupProps={{
                  title: strings.searchOperations.chooseOperationGroup,
                  subTitle: strings.searchOperations.canChooseOperationGroup,
                  placeholder: strings.searchOperations.searchOperationGroup,
                  keyToNormalize: 'groupCode',
                  labelToNormalize: 'groupName',
                  //filterBy: 'medicalFieldName',
                  onSubmit: () => { },
                }}
                isPopup
                enableFreeText={selectedFieldOfService === strings.searchOperations.operationName}
                attribute={localAttributes.localOperationGroupNameApiKey}
                queryParams={[{ key: 'objectType', value: '11' }]}
                serviceType="shaban/operation/"
                title={strings.searchOperations.operationGroup}
                disableList={selectedFieldOfService === strings.searchOperations.operationCode}
                onChange={(value: string) => setgroupCode(Number(value))}
                onReset={() => setgroupCode(0)}
              />

              {/* 2222222 */}
              <CustomLocalSearchInput
                key={`operationName-${selectedFieldOfService}`} // Dynamic key for re-rendering
                popupProps={{
                  title: strings.searchOperations.chooseOperationName,
                  subTitle: strings.searchOperations.canChooseOperationName,
                  placeholder: strings.searchOperations.searchOperationName,
                  keyToNormalize: 'operationName',
                  labelToNormalize: 'operationName',
                  //filterBy: 'medicalFieldName',
                  onSubmit: () => { },
                }}
                disableList={selectedFieldOfService === strings.searchOperations.operationCode}
                isPopup
                enableFreeText={selectedFieldOfService === strings.searchOperations.operationName}
                attribute={localAttributes.localOperationNameApiKey}
                queryParams={[{ key: 'objectType', value: '11' }, { key: 'groupCode', value: groupCode.toString() }]}
                serviceType="shaban/operation/"
                title={strings.searchOperations.operationName}
                onChange={(value: string) => setoperationName(value)}
                onReset={() => setoperationName('')}
              />

              <div className={styles.group}>
                <RadioButton
                  label={strings.searchOperations.operationCode}
                  value={strings.searchOperations.operationCode}
                  className={styles.label}
                  isSelected={selectedFieldOfService === strings.searchOperations.operationCode}
                  onSelecteRadio={(value: string) => handleSelectedFieldOfService(value)}
                  id={'operationCode'}
                />
                {strings.searchOperations.operationCodeExplanationModal && <BubbleIcon
                  className={styles.bubbleText}
                  isPopup
                  popupTitle={strings.searchOperations.operationCode}
                  popupContent={strings.searchOperations.operationCodeExplanationModal}
                  //contentClassName={styles.contentClassName}
                  text={strings.searchOperations.operationCodeExplanation}
                  info={strings.searchOperations.operationCodeExplanationModal}
                />
                }
                {/* 333333 */}
                <CustomLocalSearchInput
                  key={`operationCode-${selectedFieldOfService}`} // Dynamic key for re-rendering
                  forceReset={shouldResetOperationCode}  // Reset when the flag is true
                  popupProps={{
                    title: '',
                    subTitle: '',
                    placeholder: '',
                    keyToNormalize: 'code',
                    labelToNormalize: 'code',
                    //filterBy: 'medicalFieldName',
                    onSubmit: () => { },
                  }}
                  enableFreeText={selectedFieldOfService === strings.searchOperations.operationCode ? true : false}
                  serviceType="shaban/operation/"
                  attribute={localAttributes.localOperationCodeApiKey}
                  queryParams={[{ key: 'objectType', value: '11' }]}
                  onChange={(value: string) => { setoperationCode(value) }}
                  onReset={() => {
                    setoperationCode('');
                    //setShouldResetOperationCode(false);  // Reset the flag after reset
                  }}
                />
              </div>

              {/* 444444 */}
              <CustomLocalSearchInput
                multiSelect
                isPopup
                popupProps={{
                  title: strings.globalStrings.chooseCity,
                  subTitle: strings.globalStrings.canChooseCity,
                  placeholder: strings.globalStrings.searchCity,
                  keyToNormalize: 'code',
                  labelToNormalize: 'city',
                  //filterBy: 'city',
                  onSubmit: () => { },
                }}
                placeholder={strings.globalStrings.cityPlaceholder}
                enableFreeText
                attribute={localAttributes.localCitiesApiKey}
                title={strings.globalStrings.city}
                queryParams={[{ key: 'objectType', value: '11' }]}
                onChange={(value: string) => { setCity(value) }}
                onReset={() => setCity('')}
              />
              {/* </div> */}


              {/* <div className={styles.col2}> */}
              {/* </div>
              <div className={getAllClassNames([styles.labelWrapper])}> */}
              {/* 55555 */}
              {/* </div> */}
              <CustomLocalSearchInput
                forceReset={shouldResetOperationName}  // Reset when the flag is true
                popupProps={{
                  title: '',
                  subTitle: '',
                  placeholder: '',
                  keyToNormalize: 'name',
                  labelToNormalize: 'name',
                  //filterBy: 'medicalFieldName',
                  onSubmit: () => { },
                }}
                enableFreeText
                attribute={localAttributes.localDoctorNamesApiKey}
                title={strings.searchOperations.name}
                queryParams={[{ key: 'objectType', value: '11' }]}
                onChange={(value: string) => { setName(value) }}
                onReset={() => setName('')}
              />
            </div>
          </div>

        </div>


        {expanded && (
          <div className={styles.divExpand} ref={divExpandRef}>
            <CustomCheckboxesLocal
              //onSetSelected={(selectedData: string[]) => setWorkHours(selectedData)}
              title={strings.globalStrings.visitHours}
              options={visitHoursOptions}
            />
          </div>
        )}
        {settings.showAdvanceSearch ?
          <div className={styles.divBottom}>
            <div>
              <Text
                onClick={() => setExpanded(!expanded)}
                className={styles.textAdvance}
                text={expanded ? strings.globalStrings.closeAdvancedSearch : strings.globalStrings.advanceSearch}
              />
              {expanded ? (
                <ArrowUp className={styles.icon} />
              ) : (
                <ArrowLeft className={styles.icon} />
              )}
            </div>
            <Button
              onClick={onSubmit}
              text={strings.globalStrings.search}
              replaceClassName={styles.button}
            />
          </div> :
          <div className={styles.divBottomNoAavanced}>
            <Button
              onClick={onSubmit}
              text={strings.globalStrings.search}
              replaceClassName={styles.button}
            />
          </div>
        }
      </div>
      {
        <Popup
          ref={popupRef}
          onClose={() => handleToggleVisibility()}
          height={284}
          width={550}
          style={{ paddingBottom: '0px' }}
        >
          <AlertPopup
            title={strings.errorMessages.notice}
            subTitle={selectedFieldOfService === strings.searchOperations.operationCode ? strings.searchOperations.requiredOperationName : strings.searchOperations.requiredOperationGroup}
            showButton
            buttonText={strings.globalStrings.close}
            onClose={() => handleToggleVisibility()}
          ></AlertPopup>
        </Popup>
      }
    </div>
  );
}
